// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_transcriptUploader__w3OGC {
  padding: 2rem;
  margin: 2rem 0;
  border: 1px solid #ccc;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
@media screen and (min-width: 768px) {
  .styles_transcriptUploader__w3OGC {
    margin: 2rem;
  }
}
.styles_transcriptUploader__w3OGC h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #6ba7a8;
}
.styles_transcriptUploader__w3OGC button {
  background-color: #6ba7a8;
  border: 1px;
  border-radius: 4rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0;
}
.styles_transcriptUploader__w3OGC button:hover {
  opacity: 0.8;
}
.styles_transcriptUploader__w3OGC .styles_submit__lNJQW {
  justify-content: center;
  padding: 12px 16px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}
.styles_transcriptUploader__w3OGC .styles_uploadForm__h0nG\\+ {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.styles_transcriptUploader__w3OGC .styles_error__UTGze {
  margin: 0 auto;
}
.styles_transcriptUploader__w3OGC select, .styles_transcriptUploader__w3OGC input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  font-size: 14px;
  transition: border 0.3s;
  resize: none;
}
.styles_transcriptUploader__w3OGC select::placeholder, .styles_transcriptUploader__w3OGC input::placeholder {
  color: rgba(0, 0, 0, 0.8);
}
.styles_transcriptUploader__w3OGC select:focus, .styles_transcriptUploader__w3OGC input:focus {
  border-color: #6ba7a8;
  outline: none;
}
.styles_transcriptUploader__w3OGC input {
  width: calc(100% - 30px);
}

.styles_fieldContainer__yx-08 {
  margin-top: 16px;
  border-top: 1px dashed #ddd;
  padding-top: 16px;
  position: relative;
}
.styles_fieldContainer__yx-08 .styles_fieldContainerLegend__WQpyz {
  font-size: 14px;
  font-weight: 500;
  color: #6ba7a8;
  padding: 0 8px;
  position: absolute;
  top: -8px;
  left: 12px;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iDAAA;AACF;AAEE;EAXF;IAYI,YAAA;EACF;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;AAEE;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kDAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAAJ;AACI;EACE,YAAA;AACN;AAGE;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAIE;EACE,cAAA;AAFJ;AAIE;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,qBAAA;EACA,aAAA;AAHN;AAOE;EACE,wBAAA;AALJ;;AASA;EACE,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;AANF;AAOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AALJ","sourcesContent":[".transcriptUploader {\n  padding: 2rem;\n  margin: 2rem 0;\n  border: 1px solid #ccc;\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n\n  @media screen and (min-width: 768px){\n    margin: 2rem;\n  }\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #6ba7a8;\n  }\n\n  button {\n    background-color: #6ba7a8;\n    border: 1px;\n    border-radius: 4rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    padding: 0;\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .submit {\n    justify-content: center;\n    padding: 12px 16px;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .uploadForm {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .error{\n    margin: 0 auto;\n  }\n  select, input {\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 0.5rem;\n    font-size: 14px;\n    transition: border 0.3s;\n    resize: none;\n\n    &::placeholder {\n      color: rgba(0, 0, 0, 0.8);\n    }\n\n    &:focus {\n      border-color: #6ba7a8;\n      outline: none;\n    }\n  }\n\n  input{\n    width: calc(100% - 30px);\n  }\n}\n\n.fieldContainer {\n  margin-top: 16px;\n  border-top: 1px dashed #ddd;\n  padding-top: 16px;\n  position: relative;\n  .fieldContainerLegend {\n    font-size: 14px;\n    font-weight: 500;\n    color: #6ba7a8;\n    padding: 0 8px;\n    position: absolute;\n    top: -8px;\n    left: 12px;\n    background-color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transcriptUploader": `styles_transcriptUploader__w3OGC`,
	"submit": `styles_submit__lNJQW`,
	"uploadForm": `styles_uploadForm__h0nG+`,
	"error": `styles_error__UTGze`,
	"fieldContainer": `styles_fieldContainer__yx-08`,
	"fieldContainerLegend": `styles_fieldContainerLegend__WQpyz`
};
export default ___CSS_LOADER_EXPORT___;
